import { BaasLoadingDuration } from './baas-loading-duration.type';
/**
 * Holds loading information.
 */
export type BaasLoadingOptions = {
    /** Whether loading is enabled or disabled */
    enabled?: boolean;
    /** Custom message to show otherwise default is taken */
    message?: string;
    /** Whether to show the overlay */
    overlay?: boolean;
    /** CSS class of blocking message */
    duration?: BaasLoadingDuration;
    /** Delay before starting to avoid flickering */
    delay?: number;
    /** Whether console logging should be enabled. */
    logging?: boolean;
};

export function createDefaultBaasLoadingOptions(): BaasLoadingOptions {
    return { enabled: true, overlay: true, delay: 500 };
}
